__turbopack_context__.v({
  "button": "SelectionButton-module-scss-module__xjZdCa__button",
  "input": "SelectionButton-module-scss-module__xjZdCa__input",
  "label": "SelectionButton-module-scss-module__xjZdCa__label",
  "overlay": "SelectionButton-module-scss-module__xjZdCa__overlay",
});
